<template>
  <LayoutSection :maxWidthClass="'max-w-[1100px] mx-auto'" v-if="testimonials">
    <MainContent class="p-[2.4rem]">
      <div class="text-black text-[2rem] font-semibold text-center">
        <h4>
          {{ $t("What people are saying") }}
        </h4>
        <!-- <p class="text-[14px] text-black font-semibold text-center pt-[1.6rem]">
          {{
            $t("More than 4000 clients are already enjoying the new medicine.")
          }}
        </p> -->
      </div>
      <div class="pt-[2.4rem]">
        <div class="text-left">
          <carousel
            :items-to-show="itemsToShow"
            :breakpoints="breakpoints"
            :snapAlign="snapAlign"
          >
            <slide
              class="item px-2 sm:px-2 md:px-3 lg:px-4"
              v-for="(testimonial, slide) in testimonials"
              :key="slide"
            >
              <SubContent
                paddingClass="p-[2.2rem] flex gap-6 items-center w-full"
              >
                <Testimonial :data="testimonial"></Testimonial>
              </SubContent>
            </slide>
          </carousel>
        </div>
      </div>
    </MainContent>
  </LayoutSection>
</template>

<script>
import { defineComponent } from "vue";
import MainContent from "@/components/design/mainContent.vue";
import SubContent from "@/components/design/subContent.vue";
import Testimonial from "@/components/doctor/testimonial.vue";
import LayoutSection from "@/components/design/layoutSection.vue";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide } from "vue3-carousel";
import { testimonialService } from "@/services/testimonialService.ts";
import { config } from "@/services/configService.ts";

export default defineComponent({
  name: "OurClientsSection",
  components: {
    MainContent,
    SubContent,
    Testimonial,
    Carousel,
    Slide,
    LayoutSection,
  },
  data() {
    return {
      breakpoints: {
        0: {
          itemsToShow: 0.8,
        },
        1024: {
          itemsToShow: 2.8,
          snapAlign: "start",
        },
      },
      snapAlign: "start",
      testimonials: null,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        const apiTestimonials = await testimonialService.getTestimonials();
        this.testimonials = Array.isArray(apiTestimonials)
          ? apiTestimonials.map((post) => ({
              id: post.id,
              image: `${config.host}${config.uploads}${post.image}`,
              title: post.title,
              smallText: post.smalText ?? post.smallText,
              text: post.text,
            }))
          : [];
      } catch {
        this.testimonials = [];
      }
    },
  },
});
</script>

<style scoped></style>
